import { MessageBar, MessageBarType, Stack, Text } from '@fluentui/react';
import { bcbs_groupconfigurationsnapshot as IXrmOptions_bcbs_groupconfigurationsnapshot } from 'model/AttributeOptionSets.type';
import CustomPanel, { EPanelStyleType } from './CustomPanel';

interface IModelWarningMessageProps {
    isUnderwritingReviewApp?: boolean;
    isCompareApp?: boolean;
    canUnderwritingReview: boolean;
    statuscode?: number;
    hasModel: boolean;
}

const ModelWarningMessage: React.FC<IModelWarningMessageProps> = (props) => {
    // if we are in underwriting review and the snapshot cannot be reviewed, show a warning message
    if (props.isUnderwritingReviewApp && !props.canUnderwritingReview)
        return (
            <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                <CustomPanel
                    title="⚠️ Underwriting Review ⚠️"
                    styleType={EPanelStyleType.Yellow}
                    canCollapse={false}
                >
                    <Stack tokens={{ childrenGap: 10 }} styles={{ root: { margin: '10px' } }}>
                        <Text>The snapshot is not in a state that can be reviewed.</Text>
                        <Text>Only snapshots in "Data Entry Complete" or "MNIL Data Entry Complete" status can be reviewed.</Text>
                        <Text>Current snapshot status: {props.statuscode
                            ? IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode[props.statuscode as IXrmOptions_bcbs_groupconfigurationsnapshot.Tstatuscode].name
                            : 'N/A'}
                        </Text>
                    </Stack>
                </CustomPanel>
            </div>
        );

    // if model is not loaded, show a warning message
    if (!props.hasModel)
        return (
            <MessageBar
                messageBarType={MessageBarType.warning}
                isMultiline={true}
                styles={{ root: { margin: '10px' } }}
            >
                <Text variant='small'>
                    No snapshot loaded. Please use the {props.isCompareApp ? "Compare" : "Merge"} button in the menu to load a comparison.
                </Text>
            </MessageBar>
        );

    return null;
};

export default ModelWarningMessage;
